import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-profile-update-member',
  templateUrl: './profile-update-member.component.html',
  styleUrls: ['./profile-update-member.component.scss']
})
export class ProfileUpdateMemberComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
